import React, { FC, useEffect, useState } from 'react';
import { Table, Tooltip } from 'antd';
import { api, endpoints } from '../../../../api';
import { CustomTableContainer } from '../../../../styles/styled';
import { ExpertisesTableType, ExpertiseTableType, ExpertiseTextbookType } from '../../../ExpertisePage/types';
import { ExpertiseStatusSvgGenerator } from '../ExpertProfileComponent/ExpertProfileComponent';
import { ExpertExpertiseContainer } from './styled';

type ExpertExpertiseComponentProps = {
  currentExpertId: number | string;
};

export const ExpertExpertiseComponent: FC<ExpertExpertiseComponentProps> = ({ currentExpertId }) => {
  const [expertisesState, setExpertises] = useState<ExpertisesTableType>([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get<ExpertisesTableType>(endpoints.getExpertiseByExpert(currentExpertId));

        setExpertises(
          response.data.map((el, index) => {
            return { ...el, key: index };
          }),
        );
      } catch (err) {}
    })();
  }, [currentExpertId]);

  const expertExpertiseColumns = [
    {
      title: '№ п/п',
      dataIndex: 'number',
      key: 'number',
      render: (value: string, expertise: ExpertiseTableType) => <p>{expertise.key + 1}</p>,
    },
    {
      title: 'Наименование учебника',
      dataIndex: 'textbook',
      key: 'title',
      render: (value: ExpertiseTextbookType) => <p>{value?.title}</p>,
    },
    {
      title: 'Класс',
      dataIndex: 'textbook',
      key: 'school_classes',
      render: (value: ExpertiseTextbookType) => <p>{value?.school_classes[0].title}</p>,
    },
    {
      title: 'Автор (авторский коллектив)',
      dataIndex: 'textbook',
      key: 'author',
      render: (value: ExpertiseTextbookType) => <p>{value?.author}</p>,
    },
    {
      title: 'Наименование издательства',
      dataIndex: 'textbook',
      key: 'publisher',
      render: (value: ExpertiseTextbookType) => <p>{value?.line_of_textbooks?.application?.publisher?.title}</p>,
    },
    {
      title: 'Статус экспертизы',
      dataIndex: 'textbook',
      key: 'status',
      render: (value: ExpertiseTextbookType) => (
        <Tooltip placement="rightTop" title={value.status.name}>
          <div className="to-center">{ExpertiseStatusSvgGenerator(value.status)}</div>
        </Tooltip>
      ),
    },
    {
      title: 'Экспертный лист',
      dataIndex: 'textbook',
      key: 'expert_paper',
    },
  ];

  return (
    <ExpertExpertiseContainer>
      <CustomTableContainer>
        <Table
          columns={expertExpertiseColumns}
          dataSource={expertisesState.filter((el) => el?.status?.code !== 'decline')}
        ></Table>
      </CustomTableContainer>
    </ExpertExpertiseContainer>
  );
};
